import React, { useContext, useMemo } from 'react';
import { ComponentContext } from '../../contexts';
import { DummyRasterizer } from '../../dummy-rasterizer';
import { ceil, floor, round } from '../../utils/utils';
import { SEAT_CIRCLE_RADIUS } from '../../constants';
import { GenericRowDirection } from './interfaces';
export var GenericRow = React.memo(function (props) {
    var definition = props.definition, containerSize = props.containerSize, direction = props.direction, labelGenerator = props.labelGenerator, seatAmount = props.seatAmount, _a = props.reverse, reverse = _a === void 0 ? false : _a, _b = props.disablePadding, disablePadding = _b === void 0 ? false : _b, realAngle = props.realAngle, _c = props.dataHook, dataHook = _c === void 0 ? '' : _c, _d = props.GenericRowRasterizer, GenericRowRasterizer = _d === void 0 ? DummyRasterizer : _d, forcedRasterizedImage = props.forcedRasterizedImage, initialRasterizedImage = props.initialRasterizedImage, onRasterizedImageReady = props.onRasterizedImageReady, leaveOriginalSvg = props.leaveOriginalSvg, _e = props.cornerShapesOnly, cornerShapesOnly = _e === void 0 ? false : _e;
    var Seat = useContext(ComponentContext).Seat;
    var emptySpace = containerSize - seatAmount * SEAT_CIRCLE_RADIUS * 2;
    var spacing = 0;
    if (emptySpace > 0) {
        spacing = disablePadding ? emptySpace / (seatAmount - 1) : emptySpace / (seatAmount + 1);
    }
    else if (seatAmount > 1) {
        spacing = floor(emptySpace / (seatAmount - 1));
    }
    var sidePadding = emptySpace > 0 && !disablePadding ? spacing : 0;
    var seats = useMemo(function () {
        var newSeats = new Array(seatAmount).fill(null).map(function () { return ({
            label: labelGenerator.next().value.toString(),
        }); });
        if (reverse) {
            newSeats.reverse();
        }
        return newSeats;
    }, [seatAmount, reverse, labelGenerator]);
    var getSeatPosition = function (index) {
        var position = sidePadding + SEAT_CIRCLE_RADIUS * 2 * index + spacing * index;
        if (index === 0) {
            return ceil(position);
        }
        else if (index === seatAmount - 1) {
            return floor(position);
        }
        else {
            return round(position);
        }
    };
    return (React.createElement("svg", { "data-hook": dataHook },
        React.createElement(GenericRowRasterizer, { props: props, forcedRasterizedImage: forcedRasterizedImage, onRasterizedImageReady: onRasterizedImageReady, initialRasterizedImage: initialRasterizedImage, leaveOriginalSvg: leaveOriginalSvg },
            React.createElement(React.Fragment, null, seats.map(function (_a, index) {
                var label = _a.label;
                var x = direction === GenericRowDirection.HORIZONTAL ? getSeatPosition(index) : 0;
                var y = direction === GenericRowDirection.VERTICAL ? getSeatPosition(index) : 0;
                if (cornerShapesOnly) {
                    if (index !== 0 && index !== seats.length - 1) {
                        return null;
                    }
                }
                return (React.createElement(Seat, { x: x, y: y, definition: definition, key: label, realAngle: realAngle, index: index }, label));
            })))));
});
//# sourceMappingURL=generic-row.js.map